import { UilCalendarAlt, UilLocationPoint } from "@iconscout/react-unicons";
import Badge from "components/base/Badge";
import { dateFormatter } from "helpers/utils";
import { Card } from "react-bootstrap";

const MeetingCard = ({ meeting }: any) => {
  return (
    <Card>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start flex-wrap mb-4 gap-2">
          <div className="mb-3 mb-sm-0">
            <h4 className="line-clamp-1 mb-2 mb-sm-1">
              {meeting?.meeting_name}
            </h4>
            <div>
              <UilCalendarAlt
                className="text-primary me-2"
                width={16}
                height={16}
              />
              <span className="fw-semibold text-body-secondary fs-9">
                {dateFormatter(meeting?.meeting_start)}
              </span>
              <span className="text-body-teritary text-opacity-85"> to </span>
              <span className="fw-semibold text-body-secondary fs-9">
                {dateFormatter(meeting?.meeting_end)}
              </span>
              {meeting?.duration?.hours && (
                <span className="text-body-secondary fs-9">
                  - {meeting?.duration?.hours} Hours{" "}
                  {meeting?.duration?.minutes} Minuets
                </span>
              )}
            </div>
            {meeting?.meeting_location && (
              <div>
                <UilLocationPoint
                  className="text-primary me-2"
                  width={16}
                  height={16}
                />
                <span className="fw-semibold text-body-secondary fs-9">
                  {meeting?.meeting_location}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Badge
            variant="phoenix"
            bg={`${meeting?.meeting_day === "Tomorrow" ? "warning" : "primary"}`}
            className="me-2"
          >
            {meeting?.meeting_day}
          </Badge>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MeetingCard;
